import * as React from "react";
import { DynamicWidthContainer } from "@/react/features/styled/WidthContainers";
import { PositionedLabel } from "@/react/features/styled/PositionedLabel";
import TaggedSelect from "@/react/components/TaggedSelect";

const LabeledSelect = (props) => {
  const { prompt, ...other } = props;

  return (
    <DynamicWidthContainer>
      <PositionedLabel>{prompt}</PositionedLabel>
      <TaggedSelect {...other} />
    </DynamicWidthContainer>
  );
};

export default LabeledSelect;
